import { cva, type VariantProps } from "class-variance-authority";

export const buttonVariants = cva(
  // BASE STYLES: Rounded Full (Capsule), Smooth Transitions, Physical Feedback
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-clip-padding text-[15px] font-semibold tracking-[-0.01em] transition-all duration-150 ease-out focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-5 [&_svg]:shrink-0 active:scale-95",
  {
    variants: {
      variant: {
        default:
          "border-0 bg-[linear-gradient(90deg,var(--athr-mood-accent)_0%,var(--athr-mood-accent-hover)_100%)] text-[var(--athr-mood-text)] shadow-[var(--athr-mood-shadow)] hover:-translate-y-0.5 hover:brightness-[1.03] hover:shadow-[var(--athr-energy-shadow-hover)]",
        destructive:
          "border-0 bg-[var(--athr-danger)] text-white shadow-[0_18px_36px_-18px_rgba(220,38,38,0.28)] hover:-translate-y-0.5 hover:bg-[#b91c1c]",
        outline:
          "border border-slate-200 bg-[var(--athr-surface)] text-[var(--athr-text-secondary)] shadow-none hover:border-[var(--athr-brand-border)] hover:text-[var(--athr-brand)] hover:bg-[var(--athr-brand-mist)]",
        secondary:
          "border border-slate-200 bg-transparent text-[var(--athr-text-secondary)] shadow-none hover:border-slate-300 hover:text-[var(--athr-text-primary)] hover:bg-[var(--athr-surface-soft)]",
        ghost:
          "border-transparent bg-transparent text-[var(--athr-text-primary)] shadow-none hover:bg-[var(--athr-surface-subtle)] hover:text-[var(--athr-brand)]",
        link:
          "border-0 bg-transparent text-[var(--athr-brand)] shadow-none underline-offset-4 hover:underline",
        plain:
          "border-transparent bg-transparent text-current shadow-none hover:bg-transparent hover:text-current",
        // Glass Variant (for Headers/Overlays)
        glass:
          "border-0 chrome-glass text-[var(--athr-text-primary)] hover:bg-[var(--athr-surface-subtle)]",
      },
      size: {
        default: "h-11 px-5 py-2 sm:px-6",
        sm: "h-9 rounded-full px-4 text-sm [&_svg]:size-4",
        lg: "h-12 rounded-full px-8 text-base",
        icon: "h-11 w-11 shrink-0 p-0 [&_svg]:size-5",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
